import React, { useContext, useEffect, useState } from 'react';

import Image from 'next/image';
import { GlobalContext } from 'context';
import { SET_USER_MENUS, SET_LANGUAGES, SET_CATEGORIES } from 'context/actions/system';
import { SET_ACCOUNT, SET_BASKET_COUNT } from 'context/actions/auth';
// component
import Header from 'components/Header';
import Footer from 'components/Footer';
import DevelopeDialog from 'components/DevelopDialog';
import LoadingDialog from 'components/global/LoadingDialog';
import CustomSnackBar from 'components/CustomSnackBar';
import { SHOW_DEVELOP, SET_ALERT } from 'context/actions/system';
import { getPageList } from 'context/actions/pages';
import { getLangList } from 'context/actions/languages';
import { getCategoriesList } from 'context/actions/categories';
import { getBasketCount } from 'context/actions/basketProducts';
import Alert from '@mui/material/Alert';
import i18n from 'i18next';
import useWindowSize from 'utils/useWindowSize';

export default function HomeLayout({ children }) {
    const { sizes } = useWindowSize();
    const { state, dispatch } = useContext(GlobalContext);
    const [isGetAllData, setGetAllData] = useState(false);
    const [isTimeoutShow, setTimeoutShow] = useState(true);

    useEffect(() => {
        getDatas();

        const myStopFunction = () => {
            setTimeoutShow(false);
            clearTimeout(myTimeout);
        };

        const myTimeout = setTimeout(myStopFunction, 600);
    }, []);

    const getDatas = async () => {
        const datas = await getPageList(true, '', dispatch);
        if (datas.status === 'success') {
            console.log('OKLL', datas.data);
            dispatch({
                type: SET_USER_MENUS,
                data: datas.data,
            });
        }
        const languages = await getLangList('&isActive=1');
        if (languages.status === 'success') {
            dispatch({
                type: SET_LANGUAGES,
                data: languages.data,
            });
        }
        const categoriesRes = await getCategoriesList(null, '&fromMenu=1');
        if (categoriesRes.status === 'success') {
            dispatch({
                type: SET_CATEGORIES,
                data: categoriesRes.data,
            });
        }

        const basketRes = await getBasketCount();
        if (basketRes.status === 'success' && state?.auth?.account) {
            // Зөвхөн basketCount-ыг шинэчилнэ — account state-ийн бусад
            // field-үүдэд (type, payment_status гэх мэт) нөлөөлөхгүй.
            dispatch({ type: SET_BASKET_COUNT, data: basketRes.data?.basketCount ?? 0 });
        }
        setGetAllData(true);
    };

    return (
        <>
            <div>
                <main>
                    {isGetAllData && !isTimeoutShow ? (
                        <>
                            <Header />
                            <div>{children}</div>
                            <Footer />
                        </>
                    ) : (
                        <div className="flex flex-col flex-1 justify-center items-center h-screen">
                            <Image
                                width={sizes.sm ? 180 : 200}
                                height={sizes.sm ? 48 : 60} // Specify the height here
                                // height={48}
                                src={i18n.language === 'mn' ? '/LogoFull.png' : '/LogoFullEng.png'}
                                // src={i18n.language === 'mn' ? require('public/LogoFull.png') : require('public/LogoFull.png')}
                                // src={require('public/cover.png')}
                                alt=""
                                style={{ objectFit: 'cover' }}
                            />
                            {/* <Image
                                width={180}
                                height={48} // Specify the height here
                                // height={48}
                                src={'/loader.gif'}
                                // src={i18n.language === 'mn' ? require('public/LogoFull.png') : require('public/LogoFull.png')}
                                // src={require('public/cover.png')}
                                alt=""
                                style={{ objectFit: 'cover' }}
                            /> */}
                        </div>
                    )}
                    {state.system.showDevelop && (
                        <DevelopeDialog
                            open={state.system.showDevelop}
                            handleClose={() => {
                                console.log('asf');
                                dispatch({ type: SHOW_DEVELOP, data: false });
                            }}
                        />
                    )}

                    {state.system.showLoading && <LoadingDialog open={state.system.showLoading} />}
                    {state.system.alert.isShow && (
                        // <Alert severity={state.system.alert.type} variant="outlined" className="">
                        //     asf
                        // </Alert>

                        <CustomSnackBar
                            open={state.system.alert.isShow}
                            msg={state.system.alert.message}
                            handleClose={() => {
                                dispatch({
                                    type: SET_ALERT,
                                    data: { isShow: false, type: '', message: '' },
                                });
                            }}
                            type={state.system.alert.type}
                        />
                    )}
                </main>
            </div>
        </>
    );
}
